// import React from "react";
// import price_img from "../../static/img_price/img_price.jpg";
// import price_pdf from "../../static/pdf/price.pdf";

// const PriceList = () => {
//   return (
//     <div style={{ 
//       display: "flex", 
//       flexDirection: "column", 
//       alignItems: "center", 
//       justifyContent: "center", 
//       height: "100vh", 
//       padding: "20px", 
//       boxSizing: "border-box"
//     }}>
//       <img
//         src={price_img}
//         alt="Price List"
//         style={{
//           maxWidth: "100%",
//           maxHeight: "calc(100vh - 80px)",
//           objectFit: "contain"
//         }}
//       />
//       <a href={price_pdf} download>
//         <button style={{ 
//           marginTop: "20px", 
//           padding: "10px 20px", 
//           fontSize: "16px", 
//           cursor: "pointer", 
//           border: "none", 
//           borderRadius: "5px", 
//           background: "#007BFF", 
//           color: "white"
//         }}>
//           Скачать PDF
//         </button>
//       </a>
//     </div>
//   );
// };

// export default PriceList;
import React from "react";
import price_pdf from "../../static/pdf/price.pdf";
import { url } from "../Api/config";
const BACKEND_PDF_URL = `${url}/static/uploads/pdf/price.pdf`;
const PriceList = () => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      minHeight: "100vh",
      boxSizing: "border-box"
    }}>
      <iframe
        // src={price_pdf}
        // src={price_pdf + "#toolbar=0&navpanes=0&scrollbar=0"}
        src={BACKEND_PDF_URL + "#toolbar=0&navpanes=0&scrollbar=0"}

        title="Прайс"
        width="100%"
        height="600px"
        style={{ border: "1px solid #ccc", borderRadius: "8px" }}
      ></iframe>

      <a href={price_pdf} download>
        <button style={{
          marginTop: "20px",
          padding: "10px 20px",
          fontSize: "16px",
          cursor: "pointer",
          border: "none",
          borderRadius: "5px",
          background: "#007BFF",
          color: "white"
        }}>
          Скачать PDF
        </button>
      </a>
    </div>
  );
};

export default PriceList;


